import {Component, HostListener, OnInit} from '@angular/core';

@Component({
    selector: 'app-go-to-top',
    templateUrl: './go-to-top.component.html',
    styleUrls: ['./go-to-top.component.scss'],
    standalone: false
})
export class GoToTopComponent {

  constructor() { }

  isShow?: boolean;
  topPosToStartShowing = 600;

  @HostListener("window:scroll")
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop ||   document.body.scrollTop || 0;

    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
